<h1 mat-dialog-title>Substituir por Suplente</h1>

<form [formGroup]="form" (ngSubmit)="confirmar()">
  <div mat-dialog-content class="dialog-content">
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Suplente</mat-label>
      <mat-select formControlName="suplenteId">
        <mat-option *ngFor="let s of data.suplentes" [value]="s.id">
          {{ s.nome }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('suplenteId')?.hasError('required')"> Selecione um suplente </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Justificativa</mat-label>
      <textarea matInput formControlName="justificativa" rows="3" maxlength="1000"></textarea>
      <mat-error *ngIf="form.get('justificativa')?.hasError('required')"> Justificativa obrigatória </mat-error>
    </mat-form-field>
  </div>

  <div mat-dialog-actions>
    <button mat-button type="button" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">Confirmar</button>
  </div>
</form>
